<div [formGroup]="sgBillingInfoForm" class="admin-dialog__section">
  <div class="form-label">
    <span class="form-label__text form-label__text--section" i18n="@@adminSystem.distributorDetails.label.billingAndPaymentInfo">請求・支払い情報</span>
  </div>

  <div>
    <mat-form-field appearance="outline" class="form-field">
      <mat-label i18n="@@adminSystem.sectionGroupDetails.label.contractChannel">契約チャネル</mat-label>
      <mat-select formControlName="contractChannel" (selectionChange)="onContractChannelChange($event.value)">
        @for (item of sectionGroupContractChannel; track item) {
          <mat-option [value]="item.code">{{ item.desc }}</mat-option>
        }
      </mat-select>
      @if (sgBillingInfoForm.get('contractChannel')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.sectionGroupDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
  </div>

  @if (sgBillingInfoForm.get('contractChannel')?.value == "DISTRIBUTOR"){
      <!-- <mat-form-field appearance="outline" class="form-field">
        <mat-label>代理店名</mat-label>
        <input matInput [value]="distributor()?.name" [readonly]="true" />
      </mat-form-field> -->

    <mat-form-field appearance="outline" class="form-field">
      <mat-label i18n="@@adminSystem.sectionGroupDetails.label.billToDistributorId">代理店</mat-label>
      <mat-select formControlName="billToDistributorId">
        @for (item of distributors; track item.id) {
          <mat-option [value]="item.id">{{ item.name }}</mat-option>
        }
      </mat-select>
      @if (sgBillingInfoForm.get('contractChannel')?.hasError('required')) {
        <mat-error i18n="@@adminSystem.sectionGroupDetails.error.required">必須項目です</mat-error>
      }
    </mat-form-field>
  }

  <!-- @ifで表示非表示を切り替えると初期状態で billingSourceForm が存在しないときに ViewChild が失敗するので、代わりに [hidden] を使う -->
  <div [hidden]="sgBillingInfoForm.get('contractChannel')?.value != 'DIRECT'">
    <div class="admin-dialog__field-row">
      <mat-checkbox formControlName="hasCustomBillingRule" (change)="onHasCustomBillingRuleChange($event.checked)"></mat-checkbox>
      <span class="role-checkbox__label" i18n="@@adminSystem.distributorDetails.label.hasCustomBillingRule">詳細はシステム外で定める</span>
    </div>

    <!-- この div は [hidden] を使うと「詳細はシステム外で定める」のチェック後に描画リフレッシュのタイミングが間に合わないっぽいので @if を使う -->
    @if(sgBillingInfoForm.get('hasCustomBillingRule')?.value === true){
      <div class="admin-dialog__field-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label i18n="@@adminSystem.distributorDetails.label.customBillingRuleNotes">請求関連情報に関するメモ</mat-label>
          <textarea matInput formControlName="customBillingRuleNotes" rows="4"></textarea>
          <!-- <input matInput formControlName="customBillingRuleNotes" /> -->
        </mat-form-field>
      </div>
    }

    <!-- この div は @if を使うと 非表示時に #billingSourceFormComp に対する ViewChild が失敗するので [hidden] を使う -->
    <div [hidden]="sgBillingInfoForm.get('hasCustomBillingRule')?.value === true">
      <div class="nested-address-box">
        <app-billing-source-form #billingSourceFormComp [billingSourceForm]="getBillingSourceGroup()"></app-billing-source-form>
      </div>
      <div class="nested-address-box">
        <app-billing-terms-form [billingTermsForm]="getBillingTermsGroup()"></app-billing-terms-form>
      </div>
    </div>
  </div>
</div>